export default {
  en: {
    roomType: 'Room Type',
    keyword: 'Keyword',
    code: 'Code',
    name: 'Name',
    status: 'Status',
    newRoomType: 'New Room Type',
    updatedDate: 'Last Updated',
    remark: 'Remark',
    confirmRemoveRoomTypeTitle: 'Confirm',
    confirmRemoveRoomTypeMessage: 'Confirm to delete <strong>{roomTypeName}({roomTypeCode})</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    removeRoomTypeSuccess: 'Remove room type success'
  },
  th: {
    roomType: 'ประเภทห้อง',
    keyword: 'คำที่ต้องการค้นหา',
    code: 'โค้ด',
    name: 'ชื่อ',
    status: 'สถานะ',
    newRoomType: 'สร้างประเภทห้อง',
    updatedDate: 'แก้ไขล่าสุด',
    remark: 'หมายเหตุ',
    confirmRemoveRoomTypeTitle: 'ยืนยัน',
    confirmRemoveRoomTypeMessage: 'กรุณายืนยันการลบ <strong>{roomTypeName}({roomTypeCode})</strong>',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    removeRoomTypeSuccess: 'Remove room type success'
  }
}
